import { render, staticRenderFns } from "./CaptureModal.vue?vue&type=template&id=003708bc&"
import script from "./CaptureModal.vue?vue&type=script&lang=js&"
export * from "./CaptureModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports